/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Row1_SkillInputs */

const en_mk_model_row1_skill = /** @type {(inputs: Mk_Model_Row1_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply to DMs & reviews`)
};

const id_mk_model_row1_skill = /** @type {(inputs: Mk_Model_Row1_SkillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balas DM & review pelanggan`)
};

/**
* | output |
* | --- |
* | "Reply to DMs & reviews" |
*
* @param {Mk_Model_Row1_SkillInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_row1_skill = /** @type {((inputs?: Mk_Model_Row1_SkillInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Row1_SkillInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_row1_skill(inputs)
	return en_mk_model_row1_skill(inputs)
});